import React from 'react';

/**
 * Compact circular progress ring: current LEI vs a saved goal.
 * Reads the goal from localStorage key `lei_forecast_goal_<entityId>` (defaults to portfolio).
 */
export default function GoalRing({ current, entityId = 'portfolio', isDark = false, size = 30, testId }) {
  let goal = null;
  try {
    const g = localStorage.getItem(`lei_forecast_goal_${entityId}`);
    if (g != null && g !== '' && !Number.isNaN(Number(g))) goal = Number(g);
  } catch (e) { /* ignore */ }
  if (!goal || current == null) return null;
  const pct = Math.max(0, Math.min(100, Math.round((current / goal) * 100)));
  const reached = current >= goal;
  const color = reached ? '#10b981' : pct >= 75 ? '#0ea5e9' : '#f59e0b';
  const r = 9;
  const circ = 2 * Math.PI * r;
  return (
    <span className="relative inline-flex items-center justify-center" style={{ height: size, width: size }} title={`Goal ${goal} · ${pct}% there`} data-testid={testId}>
      <svg viewBox="0 0 24 24" width={size} height={size} className="-rotate-90">
        <circle cx="12" cy="12" r={r} fill="none" stroke={isDark ? '#22304d' : '#e2e8f0'} strokeWidth="3" />
        <circle cx="12" cy="12" r={r} fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeDasharray={`${(pct / 100) * circ} ${circ}`} />
      </svg>
      <span className="absolute text-[8px] font-bold" style={{ color }}>{pct}</span>
    </span>
  );
}
